import { createAsyncThunk, createSlice, PayloadAction } from '@reduxjs/toolkit';
import { getListPrivileges } from '@services/privilege.service';
import { IPrivilege } from '@interfaces/privilege';

export const fetchListPrivileges = createAsyncThunk('voucher/fetchPrivilegeByMerchantId', async (merchantId: string) => {
	return await getListPrivileges(merchantId);
});

export interface PrivilegeState {
	privileges: IPrivilege[];
	isLoading: boolean;
	isRefreshing: boolean;
}

const initialState = {
	privileges: [],
	isLoading: true,
	isRefreshing: false,
} satisfies PrivilegeState as PrivilegeState;

const privilegeSlice = createSlice({
	name: 'privileges',
	initialState: initialState,
	reducers: {
		fetchPrivilege: (state, action: PayloadAction<PrivilegeState>) => {
			return {
				...state.privileges,
				...action.payload,
			};
		},
		setRefreshing: (state, action: PayloadAction<boolean>) => {
			state.isRefreshing = action.payload;
		},
	},
	extraReducers(builder) {
		builder.addCase(fetchListPrivileges.pending, (state: PrivilegeState) => {
		if (state.privileges.length === 0) {
				state.isLoading = true;
			}
		});
		builder.addCase(fetchListPrivileges.fulfilled, (state: PrivilegeState, action) => {
			state.isLoading = false;
			state.isRefreshing = false;
			state.privileges = action.payload['data'] ?? [];
		});
		builder.addCase(fetchListPrivileges.rejected, (state: PrivilegeState) => {
			state.isLoading = false;
			state.isRefreshing = false;
		});
	},
});

export const privilegeReducer = privilegeSlice.reducer;
export const { setRefreshing } = privilegeSlice.actions;
export default privilegeSlice;
